import { render, staticRenderFns } from "./RequestCardOpen.vue?vue&type=template&id=4d1ba780&scoped=true&"
import script from "./RequestCardOpen.vue?vue&type=script&lang=js&"
export * from "./RequestCardOpen.vue?vue&type=script&lang=js&"
import style0 from "./RequestCardOpen.vue?vue&type=style&index=0&id=4d1ba780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ba780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d1ba780')) {
      api.createRecord('4d1ba780', component.options)
    } else {
      api.reload('4d1ba780', component.options)
    }
    module.hot.accept("./RequestCardOpen.vue?vue&type=template&id=4d1ba780&scoped=true&", function () {
      api.rerender('4d1ba780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/parts/RequestCardOpen.vue"
export default component.exports